<template>
  <a-tabs v-if="multiTabList && multiTabList.length > 1" v-model="tabActiveKey" type="editable-card" @edit="onEdit" @nextClick="onClickNext" @prevClick="onClickPrev" @tabClick="onClickTab" :hideAdd="true" :size="settings.tabSize">
    <a-tab-pane v-for="(item, index) in multiTabList" :key="index" :closable="true">
      <template slot="tab"> {{item.meta.cName}}
        <a-icon v-if="tabActiveKey == index && isReflesh" class="tab-icon anticon anticon-close ant-tabs-close-x" type="loading" title="刷新中"/>
        <a-icon v-if="tabActiveKey == index && !isReflesh" class="tab-icon anticon anticon-close ant-tabs-close-x" type="reload" @click.stop="doRefleshPage" title="刷新"/>
      </template>
    </a-tab-pane>
  </a-tabs>
  <a-tabs v-else v-model="tabActiveKey" type="editable-card" :hideAdd="true" :size="settings.tabSize">
    <a-tab-pane v-for="(item, index) in multiTabList" :key="index" :closable="true">
      <template slot="tab"> {{item.meta.cName}}</template>
    </a-tab-pane>
  </a-tabs>
</template>

<script>
import {
  mapGetters,
  mapMutations,
  mapActions
} from 'vuex';
import settings from '../../config/defaultSettings.js';

export default {
  name:'',
  props: {
    isReflesh: {
      type: Boolean,
      default: false
    },
  },
  data() {
    return {
      settings,
      collapsed: false,
      keepAliveArr: [],
      refreshControl: true
    }
  },
  created() {},
  mounted() {},
  methods: {
    ...mapActions([
      'addOneTabPage',
      'closeOneTabPage',
      'closeAllTabPage',
      'changeTabIndex',
      'refleshPage'
    ]),
    refreshChild () {
      // 先移除，再加载，强制刷新子页面
      const name = this.$refs.child.$options.name;
      this.keepAliveArr.splice(this.keepAliveArr.indexOf(name), 1);
      this.refreshControl = false;
      this.$nextTick(() => this.refreshControl = true);
    },
    afterRouterChange () {
      // 记录子组件name，用于keepalive
      const childName = this.$refs.child.$options.name;
      this.pageTabList[this.pageTabIndex].name = childName;
      if (!this.keepAliveArr.includes(childName)) {
        this.keepAliveArr.push(childName);
      }
    },
    doRefleshPage(e) {
      let that = this;
      const currentRoute = that.$router.currentRoute;
      console.log('refleshPage', that.$router, e, currentRoute);
      this.$emit('reflesh', currentRoute.name);
    },
    onEdit(activekey, action) {
      console.log('onEdit', activekey, action);
      if(action === 'remove') {
        this.closeOneTabPage({idx: activekey, $router: this.$router});
      }
    },
    onChange(activekey) {
      console.log('onChange', activekey);
      this.changeTabIndex({idx: activekey, $router: this.$router});
    },
    onClickNext() {},
    onClickPrev() {},
    onClickTab(idx) {
      console.log('onClickTab', idx, this.tabActiveKey, this.$router);
      if(idx != this.tabActiveKey) {
        this.changeTabIndex({idx: idx, $router: this.$router});
      }
    }
  },
  watch: {},
  computed: {
    ...mapGetters(["menuList", "userInfo", "breadCrumbList", "multiTabList"]),
    tabActiveKey: {
      get: function () {
        return this.$store.getters.tabActiveKey;
      },
      set: function () {},
    }
  },
}

</script>

<style scoped>
  /deep/ .ant-tabs-bar {
    margin: 0 !important;
  }
  /deep/ .tab-icon {
    width: 1.1em !important;
    height: 1.1em !important;
    font-size: 1em !important;
    color: #999999 !important;
    margin-right: 2.5px !important;
  }
  /deep/ .tab-icon:hover {
    color: rgb(24, 144, 255) !important;
  }
</style>



// WEBPACK FOOTER //
// src/views/main/multiTab.vue